import { t } from "i18next";

import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { theme } from "@/src/theme/theme";

import { formatDateSafely } from "@/src/utils/dateUtils";

interface AdditionalInfoBadgeProps {
  createdAt?: string;
  isMobile: boolean;
  position?: "top-left" | "bottom-right";
}

export const AdditionalInfoBadge = ({
  createdAt,
  isMobile,
  position = "bottom-right"
}: AdditionalInfoBadgeProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: "absolute",
        ...(position === "top-left"
          ? {
              top: 0,
              left: 0
            }
          : {
              bottom: 0,
              right: 0
            }),
        zIndex: 3,
        backgroundColor: theme.palette.semantic.primary.main,
        color: theme.palette.common.white,
        padding: isMobile ? "2px 4px" : "2px 6px",
        borderRadius: "4px",
        fontSize: isMobile ? "10px" : "12px",
        fontWeight: theme.typography.fontWeightBold,
        boxShadow: `1px 1px 2px ${theme.palette.misc.outlineBorder}`,
        whiteSpace: "nowrap",
        pointerEvents: "none"
      }}
    >
      {t("auctionAdditionalInfo.imageAddedAt")}:{" "}
      {createdAt
        ? formatDateSafely(createdAt)
        : formatDateSafely(new Date().toISOString())}
    </Box>
  );
};
